var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlagUa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 32,
    viewBox: "0 0 58 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16.0002,
    width: 58,
    height: 16,
    fill: "#FBE526"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 58,
    height: 16,
    fill: "#1193DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagUa);
export default __webpack_public_path__ + "static/media/icon-flag-ua.cb8f44d93dbca9a3919d0edbf895f7a9.svg";
export { ForwardRef as ReactComponent };